import { cloneDeep, isEqual } from 'lodash'

import { proxy } from './proxy'

export const keyValue = {
  mixins: [ proxy({ type: 'object' }) ],

  props: {
    defaultValue: {
      type: Object,
      default() {
        return {
          key: '',
          value: ''
        }
      }
    }
  },

  methods: {
    addField() {
      this.proxy.push(cloneDeep(this.defaultValue))
    },
    removeField(index) {
      this.proxy.splice(index, 1)
    },

    fillEmptyFields(fields) {
      if (fields.length === 0) {
        fields.splice(0, 0, cloneDeep(this.defaultValue))
      }

      return fields
    },

    _inputFilter(data) {
      const result = Object.keys(data).reduce((result, key) => {
        result.splice(result.length, 0, {
          key,
          value: data[key]
        })

        return result
      }, [])

      return this.fillEmptyFields(result)
    },
    _outputFilter(data) {
      return data.reduce((result, item) => {
        return Object.assign(result, { [item.key]: item.value })
      }, {})
    },

    receiveValue() {
      const value = this._inputFilter(this.value)
      if (!isEqual(this.proxy, value)) {
        this.proxy = value
      }
    },

    transmitValue() {
      const proxy = this._outputFilter(this.proxy)
      if (!isEqual(proxy, this.value)) {
        this.$emit('input', proxy)
      }
    }
  }
}

export default { keyValue }
